export default __webpack_public_path__ + "static/media/865.be8192b4.png";